import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import { Icon, RatingIcons } from '@hydra/common/components';

import { useI18n } from '@hydra/common/customHooks';

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(3)
  },
  timestamp: {
    margin: theme.spacing(0, 0.75),
    display: 'inline-block',
    fontSize: theme.typography.fontSizeSmall,
    color: theme.palette.grey[500]
  }
}));

export const directoryIcons = {
  Yelp: 'yelp'
};

export const TimeStamp = ({ datetime }) => {
  const { moment } = useI18n();
  const classes = useStyles();
  return (
    <span className={classes.timestamp}>
      {moment(datetime) && moment(datetime).format('LLL')}
    </span>
  );
};

TimeStamp.propTypes = {
  moment: PropTypes.func.isRequired,
  datetime: PropTypes.number
};

export const CriteriumOnlineReview = ({ review }) => {
  const { moment } = useI18n();
  const classes = useStyles();
  const { type, text, author, date, rating } = review;
  const icon = directoryIcons[type];
  const hasRatings = (typeof rating === 'number');

  return (
    <div className={classes.root}>
      <Icon type={icon} size='sm' />
      <TimeStamp datetime={date} moment={moment} />
      {hasRatings && <RatingIcons size='sm' max={5} type='rating' rating={rating} />}
      <div>
        {text}
        {author && <strong>{` – ${author}`}</strong>}
      </div>
    </div>
  );
};

CriteriumOnlineReview.propTypes = {
  review: PropTypes.shape({
    type: PropTypes.string,
    author: PropTypes.string,
    date: PropTypes.number,
    link: PropTypes.string,
    rating: PropTypes.number,
    text: PropTypes.string
  })
};

export default CriteriumOnlineReview;
